import { DocxCanvas } from './selection/DocxCanvas';

/** Step 2 canvas — the rendered document with text-selection field marking. */
export function DocxBuilderStepSelection() {
  return <DocxCanvas />;
}
